"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Indicator_1 = require("../_Indicator/Indicator");

var IndicatorLink_1 = require("./IndicatorLink");

var Stateful_1 = require("./Stateful");

var IndicatorLinks =
/** @class */
function (_super) {
  __extends(IndicatorLinks, _super);

  function IndicatorLinks() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.uuid = _this.props.id || uniqid_1["default"](CSSPrefix_1.lsgPre + "indicatorlinks-");
    return _this;
  }

  IndicatorLinks.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        children = _a.children,
        indicator = _a.indicator,
        activeId = _a.activeId,
        activeIndex = _a.activeIndex;
    return React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([className, CSSPrefix_1.lsgPre + "indicator-links-container"])
    }, React.createElement("ul", {
      className: CSSPrefix_1.lsgPre + "indicator-links",
      id: this.uuid,
      ref: function ref(r) {
        return _this.containerElm = r;
      }
    }, React.Children.toArray(children).map(function (child, i) {
      var active = false;
      var linkId = child.props.id || _this.uuid + "-" + i;

      if (activeId) {
        active = linkId === activeId;
      } else if (activeIndex !== undefined) {
        active = activeIndex === i;
      }

      return React.cloneElement(child, {
        id: linkId,
        key: linkId,
        className: utils_1.DomUtils.cleanupClassNames([child.props.className, active && CSSPrefix_1.lsgPre + "indicator-link__active"]),
        onClick: function onClick(ev) {
          _this.props.onChange(linkId, ev);

          child.props.onClick(ev);
        },
        refCallback: function refCallback(r) {
          if (active) {
            _this.selectedLinkElm = r;
          }

          if (child.props.refCallback) {
            child.props.refCallback(r);
          }
        }
      });
    })), indicator && React.createElement(Indicator_1.Indicator, {
      selectedItemRefCallback: function selectedItemRefCallback() {
        return _this.selectedLinkElm;
      },
      containerRefCallback: function containerRefCallback() {
        return _this.containerElm;
      }
    }));
  };

  IndicatorLinks.Link = IndicatorLink_1.IndicatorLink;
  IndicatorLinks.Stateful = Stateful_1.Stateful;
  IndicatorLinks.defaultProps = {
    onChange: function onChange() {
      /* empty */
    }
  };
  return IndicatorLinks;
}(React.Component);

exports.IndicatorLinks = IndicatorLinks;